/**
 * Get the notifications to display to the user
 * @param {NotificationStore} state
 * @returns {VvNotification[]}
 */
export const notificationsToToast = state =>
  unseenNotifications(state).filter(notification => !notification.toast.shown)

/**
 * Get the notifications not seen/acknowledge by the user
 * @param {NotificationStore} state
 * @returns {VvNotification[]}
 */
export const unseenNotifications = state =>
  Object.values(state.notifications)
    .filter(notification => !notification.seen)
    .sort(
      (notifA, notifB) =>
        new Date(notifA.triggerDate).getTime() - new Date(notifB.triggerDate).getTime()
    )
